import { CIcon } from '~/icons/types'

export const ciMarketplace: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22.03 7.987V6.3a.5.5 0 0 0-.071-.257l-1.685-2.8A.5.5 0 0 0 19.846 3H4.154a.5.5 0 0 0-.428.242L2.041 6.047a.5.5 0 0 0-.071.253v1.687a2.011 2.011 0 0 0 1.588 1.929V20H2.47a.5.5 0 0 0 0 1h19.06a.5.5 0 0 0 0-1H20.5V9.9a2.006 2.006 0 0 0 1.53-1.913Zm-2.1.994a1.042 1.042 0 0 1-1.081-.994V6.808h2.181v1.179a1.046 1.046 0 0 1-1.095.994h-.005Zm-4.253-2.173h2.177v1.183a1.043 1.043 0 0 1-1.083.994h-.013a1.042 1.042 0 0 1-1.081-.994V6.808ZM4.437 4h15.126l1.086 1.808H3.351L4.437 4ZM12.5 6.808h2.177v1.183a1.042 1.042 0 0 1-1.082.994h-.013a1.042 1.042 0 0 1-1.082-.994V6.808Zm-3.177 0H11.5v1.183a1.042 1.042 0 0 1-1.082.994h-.013a1.042 1.042 0 0 1-1.082-.994V6.808ZM6.146 7.987V6.808h2.177v1.183a1.042 1.042 0 0 1-1.082.994h-.013a1.042 1.042 0 0 1-1.082-.994v-.004Zm-3.176 0V6.808h2.176v1.179a1.045 1.045 0 0 1-1.094.994 1.042 1.042 0 0 1-1.082-.994ZM17.458 20H14.5l.009-7.024h2.957L17.458 20Zm1 0 .009-7.523a.5.5 0 0 0-.5-.5h-3.958a.5.5 0 0 0-.5.5L13.5 20H4.558V9.918c.42-.1.8-.325 1.087-.648a2.106 2.106 0 0 0 1.583.715h.013a2.107 2.107 0 0 0 1.582-.713 2.107 2.107 0 0 0 1.582.713h.013A2.107 2.107 0 0 0 12 9.272a2.106 2.106 0 0 0 1.582.713h.018a2.1 2.1 0 0 0 1.582-.713 2.1 2.1 0 0 0 1.581.713h.013a2.106 2.106 0 0 0 1.585-.716 2.1 2.1 0 0 0 1.145.664V20h-1.048Z'
    },
    {
      d:
        'M12 11.973H6a.5.5 0 0 0-.5.5v5.2a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-5.2a.5.5 0 0 0-.5-.5Zm-.5 5.2h-5v-4.2h5v4.2Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'marketplace',
  type: 'thin'
}
